module.exports = __webpack_public_path__ + "media/Home_eingebaut.35287587.mp4";